import { defineMessages } from 'react-intl';

export const HISTOGRAM_MESSAGES = defineMessages({
  zoomActionArrowUp: {
    defaultMessage: 'Up',
    id: '+MYvp4qc5Ti3ddoO',
    description:
      'Key shortcut in a tooltip shown when hovering the "Zoom in" action in the time series chart toolbar',
  },
  zoomActionArrowDown: {
    defaultMessage: 'Down',
    id: 'TKRQN9BIBeD8VT1I',
    description:
      'Key shortcut in a tooltip shown when hovering the "Zoom out" action in the time series chart toolbar',
  },
  zoomModeExplore: {
    id: 'gAPECRr427W1IZEa',
    defaultMessage: 'Explore mode',
    description:
      'Text in a tooltip shown when hovering the "Explore" mode in the histogram chart toolbar',
  },
  zoomModeZoom: {
    id: 'gllJsm/rrRr/LIng',
    defaultMessage: 'Zoom mode',
    description:
      'Text in a tooltip shown when hovering the "Zoom" mode in the histogram chart toolbar',
  },
  zoomModePan: {
    id: 'AHh4uuTMLAOichXS',
    defaultMessage: 'Pan mode',
    description:
      'Text in a tooltip shown when hovering the "Pan" mode in the histogram chart toolbar',
  },
  zoomIn: {
    id: 'g1/iHBY5uUDFWT6o',
    defaultMessage: 'Zoom in',
    description:
      'Text in a tooltip shown when hovering the "Zoom in" action in the histogram chart toolbar',
  },
  zoomOut: {
    id: 'RRZCQqo1jlLlwIyS',
    defaultMessage: 'Zoom out',
    description:
      'Text in a tooltip shown when hovering the "Zoom out" action in the histogram chart toolbar',
  },
  resetMode: {
    id: 'HeCgwHWBVFbPEvNZ',
    defaultMessage: 'Reset',
    description:
      'Text in a tooltip shown when hovering the "Reset" action in the histogram chart toolbar',
  },
  downloadAsCsv: {
    id: '5LZ+8QkdLQxXxC7M',
    defaultMessage: 'Download as CSV',
    description:
      'Text in a tooltip shown when hovering the "Download data" button in the histogram chart toolbar',
  },
  annotationsTooltipTitleValue: {
    id: 'bOr27M/3lXQFBWyp',
    defaultMessage: 'Value',
    description: 'Annotation tooltip title value',
  },
  annotationsTooltipTitleValueRange: {
    id: 'QHmb9sWOEor8eTYI',
    defaultMessage: 'Value range',
    description: 'Annotation tooltip title value range',
  },
});
